module.exports = __webpack_public_path__ + "img/1726036511964-screenshot-1726036496665.png.6c6c4fa4.webp";